import Tree from './Tree';
import inputable from '../Form/inputable';
var Select = inputable(Tree);
var TreeExport = Object.assign(Tree, {
  displayName: 'ShineoutTree',
  Select: Select,
  Field: Select
});
export default TreeExport;